
<div class="new_add_employee">
<div class="row">
<div class="col-sm-8">
    <div class="content" style="padding-bottom: 20px;border-bottom: 1px solid #dadada;">
      <h1>Adding employee in {{entityName}}
        <p class="duj_headp">{{entityAdd}} </p>
    </h1>
    <div class="form-group">

        <div class="form-container add-bottom-margin">
          <!-- <h4>Name</h4>
          <mat-form-field appearance="outline" class="w-100">
            <input
            placeholder="Enter name"
            matInput type="text"
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput type="text" placeholder="Enter name" [(ngModel)]="newEmployeeObj.requestUserName">
          </mat-form-field>
        </div>
        <div class="form-container add-bottom-margin">
            <!-- <h4>Starting Date</h4> -->
            <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()" style="padding: 0px;" >
              <mat-label>Starting Date</mat-label>
              <input matInput [matDatepicker]="picker1" [(ngModel)]="newEmployeeObj.joiningDate" readonly>
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
          
        <div class="form-container add-bottom-margin">
            <!-- <h4>Salary (In Rupees)</h4>
            <mat-form-field appearance="outline" class="w-100">
              <input
              placeholder="Enter Salary (In Rupees)"
                matInput
                #input
              />
            </mat-form-field> -->


            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Salary</mat-label>
                <input matInput type="text" placeholder="Salary" [(ngModel)]="newEmployeeObj.joiningSalary">
              </mat-form-field>

          </div>

          <div class="form-container add-bottom-margin" style="padding-bottom: 20px;">
            <h4>Salary Type:</h4>
            <mat-radio-group [(ngModel)]="newEmployeeObj.salaryType" class="d-inline-flex frt_vb">
              <mat-radio-button value="Monthly">Monthly</mat-radio-button>
              <mat-radio-button value="Weekly">Weekly</mat-radio-button>
              <mat-radio-button value="Daily">Daily</mat-radio-button>
              <mat-radio-button value="Hourly">Hourly</mat-radio-button>
            </mat-radio-group>
          </div>
          

          
          <div class="form-container add-bottom-margin">
            <div class="row">

          
            <!-- <h4>Phone</h4>
            <mat-form-field appearance="outline" class="w-100">
              <input
              placeholder="Enter phone"
                matInput
                #input
              />
            </mat-form-field> -->
            <div class="col-sm-3">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country Code</mat-label>
                <mat-select
                [(ngModel)]="selectedCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                      {{ "(" + selectedCountryCode.dial_code + ")" }}
                </mat-select-trigger>
                
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let country of countryList" [value]="country">
                  {{ country.flag }} {{ country.name }}
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-9">
              <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Phone</mat-label>
                  <input matInput type="text" placeholder="Phone" [(ngModel)]="newEmployeeObj.requestUserPhone" type="tel" minLength="3"
                  maxlength="17">
                </mat-form-field>

            </div>
          </div>
          </div>
        <div class="form-container add-bottom-margin">
          <!-- <h4>Notes</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Notes</mat-label>
            <textarea
            [(ngModel)]="newEmployeeObj.note"
            placeholder="Enter notes"
              matInput
            ></textarea>
          </mat-form-field>
        </div>
      
     
      </div>
      
      </div>
        <div class="footer">
          <button mat-stroked-button class="bck_btn" (click)="goToBackWithParams()"> Back </button>
          <button
        (click)="onCreate()"
        mat-flat-button
        color="accent"
        [disabled]="!newEmployeeObj.requestUserName
        || !newEmployeeObj.joiningDate ||
        !newEmployeeObj.joiningSalary ||
        !newEmployeeObj.salaryType ||
        !newEmployeeObj.requestUserPhone || formChecker()
        "
        class="next"
      >
        Create
      </button>
        </div>
  </div>

      <div class="col-sm-4">
        <div class="faq">
          <mat-accordion>
              <mat-expansion-panel [expanded]="panelState[0]" (opened)="panelState[0] = true"
              (closed)="panelState[0] = false"
                                  >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    How the new employee going to get this invitation?
                  </mat-panel-title>
                 
                </mat-expansion-panel-header>
                <p>The new employee needs to install the LookzUp Business app from Google Play Store or Apple App Store. Once the new employee logs inside the LookzUp Business app, he/she can see the invitation in Home screen or in Employee profile section.</p>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="panelState[1]" (opened)="panelState[1] = true"
              (closed)="panelState[1] = false"
                                  >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Is the employee phone number important while sending invitation?

                  </mat-panel-title>
                 
                </mat-expansion-panel-header>
                <p>Yes. The new joinee must need to sign-up in the LookzUp business app with the same number to get the invitation. Otherwise the on-boarding will not happen.</p>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="panelState[2]" (opened)="panelState[2] = true"
              (closed)="panelState[2] = false"
                                  >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    How many invitation one can send with one employee pack?
                  </mat-panel-title>
                 
                </mat-expansion-panel-header>
                <p>Business owner can send multiple invitation with one pack. It's only become countable, if the employee accept the invitation and joins the business. </p>
              </mat-expansion-panel>
        
            </mat-accordion>
        </div>
      </div>
    </div>
</div>